// src/modules/login/Login.jsx
import { FLASH_KEY } from '@app/utils/define';
import {userManager} from '@app/utils/oidc';
import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';
// import './Login.scss';

const LoginSSO = () => {
    const {search} = useLocation();
    const [serverError, setServerError] = useState(null);

    // Bắt lỗi do server trả về ?error=invalid_credentials
    useEffect(() => {
        const params = new URLSearchParams(search);
        if (
            params.get('error') === 'invalid_credentials' &&
            serverError === null
        ) {
            setServerError('Sai tên đăng nhập hoặc mật khẩu.');
        }
    }, [search, serverError]);

    useEffect(() => {
        const raw = localStorage.getItem(FLASH_KEY);

        if (!raw) return;
        try {
            const { level = 'info', text = '' } = JSON.parse(raw);
            if (text) toast[level]?.(text);
        } catch {}
        localStorage.removeItem(FLASH_KEY);
    }, []);

    // Hàm khởi động flow OIDC
    const handleLogin = () => {
        userManager
            .signinRedirect() // Tự động build URL /connect/authorize?client_id=…&code_challenge=…&state=… :contentReference[oaicite:0]{index=0}
            .catch((err) => console.error('OIDC signinRedirect error', err));
    };

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <h1>
                        <b>CNTT 108</b>
                    </h1>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">Đăng nhập bằng SSO</p>

                    {serverError && (
                        <div className="alert alert-danger" role="alert">
                            {serverError}
                        </div>
                    )}

                    <button
                        type="button"
                        className="btn btn-primary btn-block"
                        onClick={handleLogin}
                    >
                        Đăng nhập
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginSSO;
